/* Tap redesign v2 motion: header, smooth scroll, reveals, scenes, hero tabs, stacked panels, marquee, journey, counters, integrations board, live pricing.
   Plain JS. Lenis is loaded on demand for pages that use the tap-rd sections. Everything respects prefers-reduced-motion. */
(function () {
  'use strict';
  if (window.TRD) return;
  window.TRD = true;

  var d = document, root = d.documentElement;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var HOLD = 2600;
  root.classList.add('trd-js');

  function qsa(s, el) { return Array.prototype.slice.call((el || d).querySelectorAll(s)); }
  function isDesk() { return window.matchMedia('(min-width: 1024px)').matches; }
  function headerH() { return parseInt(getComputedStyle(root).getPropertyValue('--trdh-h'), 10) || 72; }
  function watch(els, cb, opts) {
    if (!('IntersectionObserver' in window)) { els.forEach(function (e) { cb(e, true, null); }); return null; }
    var io = new IntersectionObserver(function (ents) {
      ents.forEach(function (en) { cb(en.target, en.isIntersecting, io); });
    }, opts || { threshold: 0.2 });
    els.forEach(function (e) { io.observe(e); });
    return io;
  }
  function fmt(v, dec) { return Number(v).toLocaleString('en-US', { minimumFractionDigits: dec, maximumFractionDigits: dec }); }
  function countTo(el, to, dec, dur) {
    dec = dec || 0;
    if (reduce) { el.textContent = fmt(to, dec); return; }
    var start = null;
    function step(t) {
      if (!start) start = t;
      var p = Math.min(1, (t - start) / dur), e = 1 - Math.pow(1 - p, 3);
      el.textContent = fmt(to * e, dec);
      if (p < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }

  /* ---------- header ---------- */
  var drawerToggle = function () {};
  function header() {
    var h = d.querySelector('[data-trdh]');
    if (!h) return;
    function setH() {
      var hh = Math.round(h.getBoundingClientRect().height);
      root.style.setProperty('--trdh-h', hh + 'px');
      root.style.setProperty('--header-height', hh + 'px');
      root.style.setProperty('--sticky-header-enabled', '1');
    }
    setH();
    window.addEventListener('resize', setH);
    var scrolled = false;
    function onScroll() {
      var s = window.scrollY > 8;
      if (s !== scrolled) { scrolled = s; h.classList.toggle('is-scrolled', s); setTimeout(setH, 320); }
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();

    var items = qsa('[data-trdh-item]', h), openItem = null, tIn, tOut;
    function close() {
      if (!openItem) return;
      openItem.classList.remove('is-open');
      openItem.querySelector('.trdh__top').setAttribute('aria-expanded', 'false');
      openItem = null;
      h.classList.remove('has-open');
    }
    function open(it) {
      if (openItem === it) return;
      close();
      openItem = it;
      it.classList.add('is-open');
      h.classList.add('has-open');
      it.querySelector('.trdh__top').setAttribute('aria-expanded', 'true');
    }
    var canHover = window.matchMedia('(hover: hover)').matches;
    items.forEach(function (it) {
      var btn = it.querySelector('.trdh__top');
      btn.addEventListener('click', function (e) { e.preventDefault(); if (openItem === it) close(); else open(it); });
      it.addEventListener('mouseenter', function () {
        if (!isDesk() || !canHover) return;
        clearTimeout(tOut);
        tIn = setTimeout(function () { open(it); }, openItem ? 0 : 80);
      });
      it.addEventListener('mouseleave', function () {
        clearTimeout(tIn);
        tOut = setTimeout(function () { if (openItem === it) close(); }, 180);
      });
    });
    d.addEventListener('click', function (e) { if (openItem && !openItem.contains(e.target)) close(); });
    var scrim = h.querySelector('[data-trdh-scrim]');
    if (scrim) scrim.addEventListener('click', close);

    var burger = h.querySelector('[data-trdh-burger]');
    drawerToggle = function (on) {
      if (on === undefined) on = !h.classList.contains('is-drawer');
      h.classList.toggle('is-drawer', on);
      if (burger) burger.setAttribute('aria-expanded', on ? 'true' : 'false');
      root.style.overflow = on ? 'hidden' : '';
      root.classList.toggle('trdh-drawer-open', on);
      setH();
    };
    if (burger) burger.addEventListener('click', function () { drawerToggle(); });
    qsa('.trdh__drawer a', h).forEach(function (a) { a.addEventListener('click', function () { drawerToggle(false); }); });
    window.addEventListener('resize', function () { if (isDesk() && h.classList.contains('is-drawer')) drawerToggle(false); });
    d.addEventListener('keydown', function (e) { if (e.key === 'Escape') { close(); if (h.classList.contains('is-drawer')) drawerToggle(false); } });

    var cnt = h.querySelector('[data-trdh-count]');
    var cartEl = h.querySelector('.trdh__cart[data-auto-hide]');
    function setCount(n) {
      if (cartEl) cartEl.classList.toggle('is-hidden', !(n > 0));
      if (!cnt) return;
      cnt.textContent = n; cnt.setAttribute('data-n', n);
    }
    function refresh() {
      var base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      fetch(base + 'cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (c) { setCount(c.item_count); }).catch(function () {});
    }
    ['cart:change', 'cart:refresh', 'cart:updated'].forEach(function (ev) {
      d.addEventListener(ev, function (e) {
        var c = e.detail && e.detail.cart;
        if (c && typeof c.item_count === 'number') setCount(c.item_count); else refresh();
      });
    });
  }

  /* ---------- smooth scroll ---------- */
  function smooth() {
    if (reduce || !d.querySelector('main .trd:not(.trdf)')) return;
    var s = d.createElement('script');
    s.src = 'https://cdn.jsdelivr.net/npm/lenis@1.1.13/dist/lenis.min.js';
    s.async = true;
    s.onload = function () {
      if (!window.Lenis) return;
      var l = new window.Lenis({ lerp: 0.1, smoothWheel: true });
      window.__trdLenis = l;
      function raf(t) { l.raf(t); requestAnimationFrame(raf); }
      requestAnimationFrame(raf);
      function check() {
        var locked = getComputedStyle(root).overflow === 'hidden' || getComputedStyle(d.body).overflow === 'hidden';
        if (locked) l.stop(); else l.start();
      }
      var mo = new MutationObserver(check);
      mo.observe(root, { attributes: true, attributeFilter: ['class', 'style'] });
      mo.observe(d.body, { attributes: true, attributeFilter: ['class', 'style'] });
      d.addEventListener('click', function (e) {
        var a = e.target.closest && e.target.closest('a[href*="#"]');
        if (!a) return;
        var url;
        try { url = new URL(a.href, location.href); } catch (err) { return; }
        if (url.pathname !== location.pathname || !url.hash || url.hash.length < 2) return;
        var t = d.getElementById(decodeURIComponent(url.hash.slice(1)));
        if (!t) return;
        e.preventDefault();
        l.scrollTo(t, { offset: -(headerH() + 8) });
        history.replaceState(null, '', url.hash);
      });
    };
    d.head.appendChild(s);
  }

  /* ---------- reveals + counters ---------- */
  function reveals(scope) {
    var els = qsa('[data-trd-reveal]:not(.is-in)', scope);
    if (reduce) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    watch(els, function (el, vis, io) { if (vis) { el.classList.add('is-in'); if (io) io.unobserve(el); } }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
  }
  function counters(scope) {
    var els = qsa('[data-trd-count]', scope);
    if (reduce) return;
    els.forEach(function (el) { el.textContent = fmt(0, parseInt(el.getAttribute('data-dec'), 10) || 0); });
    watch(els, function (el, vis, io) {
      if (!vis) return;
      if (io) io.unobserve(el);
      countTo(el, parseFloat(el.getAttribute('data-to')) || 0, parseInt(el.getAttribute('data-dec'), 10) || 0, 1600);
    }, { threshold: 0.5 });
  }

  /* ---------- scenes ---------- */
  function Scene(el) {
    this.el = el;
    this.steps = (el.getAttribute('data-steps') || '').split(',').filter(Boolean).map(Number);
    this.loop = el.getAttribute('data-loop') !== 'false';
    this.brands = (el.getAttribute('data-brands') || '').split(',').filter(Boolean);
    this.hold = parseInt(el.getAttribute('data-hold'), 10) || HOLD;
    this.rotate = parseInt(el.getAttribute('data-rotate'), 10) || 0;
    this.round = -1;
    this.timers = [];
    this.playing = false;
    this.visible = false;
    qsa('[data-type-at]', el).forEach(function (t) { t.__full = t.textContent; });
    el.__scene = this;
  }
  Scene.prototype.clear = function () { this.timers.forEach(clearTimeout); this.timers = []; };
  Scene.prototype.classes = function (n) { for (var i = 1; i <= 12; i++) this.el.classList.toggle('s' + i, i <= n); };
  Scene.prototype.reset = function () {
    this.clear();
    this.playing = false;
    this.classes(0);
    qsa('[data-count-at]', this.el).forEach(function (c) { c.textContent = '0'; });
    qsa('[data-type-at]', this.el).forEach(function (t) { t.textContent = ''; });
    if (this.brands.length) { this.el.style.setProperty('--brand', this.brands[0]); this.el.setAttribute('data-bi', '0'); }
  };
  /* Types a question letter by letter, or streams an answer word by word. */
  Scene.prototype.type = function (t) {
    var self = this, full = t.__full || '', words = t.getAttribute('data-type') === 'word';
    var parts = words ? full.split(/(\s+)/) : full.split(''), i = 0, speed = (words ? 70 : 42) * (self.speed || 1);
    t.textContent = '';
    (function tick() {
      if (i >= parts.length) return;
      t.textContent += parts[i++] + (words && i < parts.length ? parts[i++] : '');
      self.timers.push(setTimeout(tick, speed));
    })();
  };
  Scene.prototype.onStep = function (n) {
    var el = this.el, self = this;
    qsa('[data-type-at="' + n + '"]', el).forEach(function (t) { self.type(t); });
    qsa('[data-count-at="' + n + '"]', el).forEach(function (c) { countTo(c, parseFloat(c.getAttribute('data-to')) || 0, 0, 900); });
    if (this.brands.length && n >= 2) {
      el.style.setProperty('--brand', this.brands[(n - 1) % this.brands.length]);
      el.setAttribute('data-bi', String((n - 1) % 4));
    }
  };
  Scene.prototype.total = function () { return this.steps.reduce(function (a, b) { return a + b; }, 0); };
  Scene.prototype.finish = function () {
    this.clear();
    this.playing = false;
    this.classes(this.steps.length || 5);
    qsa('[data-count-at]', this.el).forEach(function (c) { c.textContent = fmt(parseFloat(c.getAttribute('data-to')) || 0, 0); });
    qsa('[data-type-at]', this.el).forEach(function (t) { t.textContent = t.__full || ''; });
  };
  Scene.prototype.play = function (done) {
    var self = this;
    this.reset();
    if (this.rotate) { this.round = (this.round + 1) % this.rotate; this.el.setAttribute('data-r', String(this.round)); }
    if (reduce) { this.finish(); if (done) done(); return; }
    this.playing = true;
    var t = 0;
    var sp = this.speed || 1;
    this.steps.forEach(function (ms, i) {
      t += ms * sp;
      self.timers.push(setTimeout(function () { self.classes(i + 1); self.onStep(i + 1); }, t));
    });
    this.timers.push(setTimeout(function () {
      self.playing = false;
      if (done) done();
      else if (self.loop && self.visible) self.timers.push(setTimeout(function () { self.play(); }, 500));
    }, t + this.hold));
  };

  function scenes(scope) {
    qsa('[data-trd-scene]', scope).forEach(function (el) {
      if (el.__scene || el.closest('[data-trd-tabs]') || el.closest('[data-trd-journey]')) return;
      var sc = new Scene(el);
      if (reduce) { sc.finish(); return; }
      sc.reset();
      watch([el], function (e, vis) {
        sc.visible = vis;
        if (vis && !sc.playing) sc.play();
      }, { threshold: 0.35 });
    });
  }

  /* ---------- hero tabs ---------- */
  function tabs(scope) {
    qsa('[data-trd-tabs]', scope).forEach(function (box) {
      if (box.__tabs) return;
      box.__tabs = true;
      var tabEls = qsa('[data-trd-tab]', box), panels = qsa('[data-trd-panel]', box), cur = 0, visible = false;
      /* Tab scenes play faster than standalone ones and hold briefly, so the hero keeps moving. */
      var SPEED = parseFloat(box.getAttribute('data-speed')) || 0.72, HOLD_MAX = parseInt(box.getAttribute('data-hold-max'), 10) || 1700;
      var list = panels.map(function (p) {
        var s = p.querySelector('[data-trd-scene]');
        if (!s) return null;
        var sc = new Scene(s); sc.loop = false; sc.speed = SPEED; sc.hold = Math.min(sc.hold, HOLD_MAX);
        return sc;
      });
      var bar = box.querySelector('.trd-tabsbar'), pill = box.querySelector('.trd-tabsbar__pill');
      var ring = pill ? pill.querySelector('rect') : null, perim = 0, prog = null;
      /* The dark pill slides to the active tab and traces its own outline while that tab plays. */
      function sizeRing(w, hgt) {
        if (!ring || !w || !hgt) return;
        ring.setAttribute('x', 1); ring.setAttribute('y', 1);
        ring.setAttribute('width', Math.max(0, w - 2)); ring.setAttribute('height', Math.max(0, hgt - 2));
        ring.setAttribute('rx', (hgt - 2) / 2);
        perim = 2 * Math.max(0, w - hgt) + Math.PI * (hgt - 2);
        ring.style.strokeDasharray = perim;
        ring.style.strokeDashoffset = perim;
      }
      function runRing(dur) {
        if (!ring || reduce || !ring.animate) return;
        if (prog) prog.cancel();
        prog = ring.animate([{ strokeDashoffset: perim }, { strokeDashoffset: 0 }], { duration: dur, easing: 'linear', fill: 'forwards' });
        if (!visible) prog.pause();
      }
      function movePill(instant) {
        var t = tabEls[cur];
        if (!pill || !t) return;
        if (instant) pill.style.transition = 'none';
        pill.style.width = t.offsetWidth + 'px';
        pill.style.transform = 'translateX(' + t.offsetLeft + 'px)';
        sizeRing(t.offsetWidth, pill.offsetHeight);
        if (instant) { void pill.offsetWidth; pill.style.transition = ''; }
        if (bar && bar.scrollWidth > bar.clientWidth) bar.scrollTo({ left: t.offsetLeft - (bar.clientWidth - t.offsetWidth) / 2, behavior: instant ? 'auto' : 'smooth' });
      }
      function mark(i) {
        if (i !== cur) box.classList.add('is-switched');
        var nx = panels[(i + 1) % panels.length], im = nx && nx.querySelector('img[loading="lazy"]');
        if (im) im.loading = 'eager';
        panels.forEach(function (p, k) { p.classList.toggle('is-active', k === i); });
        tabEls.forEach(function (t, k) {
          t.classList.toggle('is-active', k === i);
          t.setAttribute('aria-selected', k === i ? 'true' : 'false');
        });
        cur = i;
        movePill(false);
      }
      function show(i) {
        list.forEach(function (sc) { if (sc) sc.clear(); });
        mark(i);
        var sc = list[i];
        if (!sc) return;
        if (reduce) { sc.finish(); return; }
        runRing(sc.total() * SPEED + sc.hold);
        sc.play(function () { if (visible) show((cur + 1) % panels.length); });
      }
      /* /page#anchor opens the matching tab (menu links point at tabs). */
      function fromHash() {
        var h = decodeURIComponent((location.hash || '').slice(1)), k = -1;
        if (!h) return false;
        tabEls.forEach(function (t, j) { if (t.getAttribute('data-anchor') === h) k = j; });
        if (k < 0) return false;
        if (visible) show(k); else mark(k);
        return true;
      }
      window.addEventListener('hashchange', fromHash);
      movePill(true);
      fromHash();
      window.addEventListener('resize', function () { movePill(true); });
      if (d.fonts && d.fonts.ready) d.fonts.ready.then(function () { movePill(true); });
      tabEls.forEach(function (t, k) { t.addEventListener('click', function () { show(k); }); });
      box.addEventListener('keydown', function (e) {
        if (!e.target.getAttribute || e.target.getAttribute('role') !== 'tab') return;
        if (e.key === 'ArrowRight') { show((cur + 1) % tabEls.length); tabEls[cur].focus(); }
        if (e.key === 'ArrowLeft') { show((cur - 1 + tabEls.length) % tabEls.length); tabEls[cur].focus(); }
      });
      if (reduce) { list.forEach(function (sc) { if (sc) sc.finish(); }); box.classList.add('trd-tabs-paused'); return; }
      list.forEach(function (sc) { if (sc) sc.reset(); });
      watch([box], function (el, vis) {
        var was = visible;
        visible = vis;
        box.classList.toggle('trd-tabs-paused', !vis);
        if (!vis && prog) prog.pause();
        if (vis && !was) show(cur);
      }, { threshold: 0.3 });
    });
  }

  /* ---------- logo marquee ---------- */
  /* Clones the logo set until the track covers the screen plus one set, then scrolls by exactly one set, so it never shows a gap. */
  function marquee(scope) {
    if (reduce) return;
    qsa('.trd-mq', scope).forEach(function (mq) {
      if (mq.__mq) return;
      mq.__mq = true;
      var track = mq.querySelector('.trd-mq__track'), first = mq.querySelector('.trd-mq__set');
      if (!track || !first) return;
      function fit() {
        var w = first.getBoundingClientRect().width;
        if (!w) return;
        var need = Math.ceil(mq.clientWidth / w) + 1;
        for (var have = qsa('.trd-mq__set', track).length; have < need; have++) {
          var c = first.cloneNode(true);
          c.setAttribute('aria-hidden', 'true');
          qsa('img', c).forEach(function (im) { im.removeAttribute('loading'); im.alt = ''; });
          track.appendChild(c);
        }
        track.style.setProperty('--mqw', w + 'px');
        mq.classList.add('is-fit');
      }
      fit();
      qsa('img', first).forEach(function (im) { if (!im.complete) im.addEventListener('load', fit, { once: true }); });
      window.addEventListener('resize', fit);
    });
  }

  /* ---------- stacked panels ---------- */
  /* Panels are sticky on desktop; each one shrinks a little as the next slides over it. */
  function stack(scope) {
    if (reduce) return;
    qsa('[data-trd-stack]', scope).forEach(function (w) {
      if (w.__stack) return;
      w.__stack = true;
      var panels = qsa('.trd-panel', w), ticking = false;
      function upd() {
        ticking = false;
        if (!isDesk()) { panels.forEach(function (p) { p.style.transform = ''; p.style.filter = ''; }); return; }
        for (var i = 0; i < panels.length - 1; i++) {
          var pr = panels[i].getBoundingClientRect(), nr = panels[i + 1].getBoundingClientRect();
          var k = Math.max(0, Math.min(1, (pr.bottom - nr.top) / pr.height));
          panels[i].style.transform = k > 0 ? 'scale(' + (1 - 0.06 * k).toFixed(4) + ')' : '';
          panels[i].style.filter = k > 0 ? 'brightness(' + (1 - 0.12 * k).toFixed(3) + ')' : '';
        }
      }
      window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(upd); } }, { passive: true });
      window.addEventListener('resize', upd);
      upd();
    });
  }

  /* ---------- pinned lead journey ---------- */
  function journey(scope) {
    qsa('[data-trd-journey]', scope).forEach(function (w) {
      var sEl = w.querySelector('[data-trd-scene]');
      if (!sEl) return;
      var sc = new Scene(sEl), stepEls = qsa('[data-trd-jstep]', w), n = stepEls.length || 5, cur = 0;
      function set(k) {
        if (k === cur) return;
        var prev = cur;
        cur = k;
        sc.classes(k);
        for (var j = prev + 1; j <= k; j++) sc.onStep(j);
        stepEls.forEach(function (s, i) { s.classList.toggle('is-on', i < k); });
      }
      if (reduce) { sc.finish(); stepEls.forEach(function (s) { s.classList.add('is-on'); }); return; }
      sc.reset();
      var pinned = false, ticking = false, played = false;
      function upd() {
        ticking = false;
        var on = isDesk();
        if (on !== pinned) { pinned = on; w.classList.toggle('is-pinned', on); }
        if (!pinned) return;
        var r = w.getBoundingClientRect(), vh = window.innerHeight, total = r.height - vh;
        var p = total > 0 ? Math.min(1, Math.max(0, (-r.top + vh * 0.2) / total)) : 1;
        set(Math.min(n, Math.max(1, Math.floor(p * n) + 1)));
      }
      window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(upd); } }, { passive: true });
      window.addEventListener('resize', upd);
      upd();
      watch([w], function (el, vis) {
        if (!vis || pinned || played) return;
        played = true;
        var k = 0;
        (function tick() { k++; set(k); if (k < n) setTimeout(tick, 800); })();
      }, { threshold: 0.25 });
    });
  }

  /* ---------- integrations board ---------- */
  /* Draws a curve from each source to the Tap hub and from the hub to each app, then sends a dot along a random pair. */
  function flow(scope) {
    qsa('[data-trd-flow]', scope).forEach(function (box) {
      if (box.__flow) return;
      box.__flow = true;
      var svg = box.querySelector('.trd-flow__svg'), hub = box.querySelector('[data-flow-hub]');
      var srcs = qsa('[data-flow-src]', box), dsts = qsa('[data-flow-dst]', box);
      if (!svg || !hub || !dsts.length) return;
      var NS = 'http://www.w3.org/2000/svg', pin = [], pout = [], visible = false, timer = null, last = -1;
      function rel(el) {
        var b = box.getBoundingClientRect(), r = el.getBoundingClientRect();
        return { l: r.left - b.left, t: r.top - b.top, r: r.right - b.left, b: r.bottom - b.top, cx: r.left - b.left + r.width / 2, cy: r.top - b.top + r.height / 2 };
      }
      function curve(a, z, horiz) {
        if (horiz) { var mx = (a.x + z.x) / 2; return 'M' + a.x + ' ' + a.y + 'C' + mx + ' ' + a.y + ' ' + mx + ' ' + z.y + ' ' + z.x + ' ' + z.y; }
        var my = (a.y + z.y) / 2; return 'M' + a.x + ' ' + a.y + 'C' + a.x + ' ' + my + ' ' + z.x + ' ' + my + ' ' + z.x + ' ' + z.y;
      }
      function mk(dd) { var p = d.createElementNS(NS, 'path'); p.setAttribute('d', dd); svg.appendChild(p); return p; }
      function draw() {
        var h = rel(hub), horiz = srcs.length ? rel(srcs[0]).r < h.l : true;
        svg.setAttribute('viewBox', '0 0 ' + box.clientWidth + ' ' + box.clientHeight);
        qsa('path', svg).forEach(function (p) { p.remove(); });
        pin = srcs.map(function (s) {
          var r = rel(s);
          return mk(curve(horiz ? { x: r.r, y: r.cy } : { x: r.cx, y: r.b }, horiz ? { x: h.l, y: h.cy } : { x: h.cx, y: h.t }, horiz));
        });
        pout = dsts.map(function (s) {
          var r = rel(s);
          return mk(curve(horiz ? { x: h.r, y: h.cy } : { x: h.cx, y: h.b }, horiz ? { x: r.l, y: r.cy } : { x: r.cx, y: r.t }, horiz));
        });
      }
      function run(path, c, dur, done) {
        var len = path.getTotalLength(), t0 = null;
        function step(t) {
          if (!t0) t0 = t;
          var p = Math.min(1, (t - t0) / dur), e = p < 0.5 ? 2 * p * p : 1 - Math.pow(-2 * p + 2, 2) / 2, pt = path.getPointAtLength(len * e);
          c.setAttribute('cx', pt.x); c.setAttribute('cy', pt.y);
          if (p < 1) requestAnimationFrame(step); else done();
        }
        requestAnimationFrame(step);
      }
      function flash(el, cls, ms) { el.classList.add(cls); setTimeout(function () { el.classList.remove(cls); }, ms); }
      function send() {
        if (!visible || !pout.length) return;
        var i = Math.floor(Math.random() * Math.max(1, pin.length)), j;
        do { j = Math.floor(Math.random() * pout.length); } while (pout.length > 1 && j === last);
        last = j;
        var c = d.createElementNS(NS, 'circle'), a = pin[i], z = pout[j];
        c.setAttribute('r', '4.5'); c.setAttribute('cx', '-20'); c.setAttribute('cy', '-20');
        svg.appendChild(c);
        if (srcs[i]) flash(srcs[i], 'is-hit', 700);
        function out() {
          hub.classList.remove('is-pulse'); void hub.offsetWidth; hub.classList.add('is-pulse');
          run(z, c, 900, function () { c.remove(); flash(dsts[j], 'is-hit', 1200); });
        }
        if (a) run(a, c, 800, out); else out();
      }
      /* The lines are measured only once the board is near the screen, so page load doesn't pay for the layout. */
      var drawn = false;
      function redraw() { if (drawn) draw(); }
      watch([box], function (el, near, io) {
        if (!near) return;
        if (io) io.unobserve(el);
        drawn = true; draw();
        if ('ResizeObserver' in window) new ResizeObserver(redraw).observe(box); else window.addEventListener('resize', redraw);
        if (d.fonts && d.fonts.ready) d.fonts.ready.then(redraw);
      }, { rootMargin: '400px 0px' });
      if (reduce) return;
      watch([box], function (el, vis) {
        visible = vis;
        clearInterval(timer);
        if (vis) { send(); timer = setInterval(send, 1150); }
      }, { threshold: 0.25 });
    });
  }

  /* ---------- live pricing ---------- */
  var FALLBACK = [
    { t: 'Digital Business Cards', g: 'Share who you are, instantly', m: 4, y: 2.8, pop: false, sales: false, f: ['NFC cards included', 'Fully branded digital cards', 'Lead capture forms', 'Instant contact sharing', 'Mobile app access'] },
    { t: 'Lead Capture', g: 'Turn intros into leads', m: 6, y: 4.2, pop: false, sales: false, f: ['All in Digital Business Cards +', 'Custom lead capture forms', 'Departments & templates', 'Roles & permissions', 'Native CRM integrations', 'Lead scoring'] },
    { t: 'Sales Intelligence', g: 'Turn meetings into deals', m: 20, y: 14, pop: true, sales: false, f: ['All in Lead Capture +', 'AI meeting intelligence', 'AI notes & summaries', 'AI chat assistant', 'Advanced team insights'] },
    { t: 'Sales Autopilot', g: 'Put growth on autopilot', m: null, y: null, pop: false, sales: true, f: ['All in Sales Intelligence +', 'Unlimited AI meetings', 'AI enrichment agents', 'Customer success manager', 'Priority support'] }
  ];
  var CHECK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>';
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function money(v) { var n = Number(v); return '$' + (n % 1 ? n.toFixed(2) : String(n)); }
  function pricing(scope) {
    qsa('[data-trd-pricing]', scope).forEach(function (box) {
      var grid = box.querySelector('[data-trd-plans]'), save = box.querySelector('[data-trd-save]');
      var trial = box.getAttribute('data-trial-url') || '#', sales = box.getAttribute('data-sales-url') || '#';
      var on = box.querySelector('[data-bill].is-on'), period = on ? on.getAttribute('data-bill') : 'year', plans = FALLBACK.slice();
      function card(p) {
        var v = period === 'year' ? p.y : p.m, custom = p.sales || v == null || isNaN(Number(v));
        var price = custom ? '<strong>Custom</strong>' : '<strong>' + money(v) + '</strong><span>/ member / month</span>';
        var note = custom ? 'For larger teams' : (period === 'year' ? 'Billed yearly' : 'Billed monthly');
        var cta = custom ? '<a class="trd-btn trd-btn--ghost" href="' + esc(sales) + '">Talk to sales</a>'
          : '<a class="trd-btn ' + (p.pop ? 'trd-btn--primary' : 'trd-btn--ghost') + '" href="' + esc(trial) + '">Start free trial</a>';
        return '<div class="trd-plan' + (p.pop ? ' is-pop' : '') + '">' + (p.pop ? '<span class="trd-plan__pop">Most popular</span>' : '') +
          '<div><h3>' + esc(p.t) + '</h3><p class="trd-plan__tag">' + esc(p.g) + '</p></div>' +
          '<div class="trd-plan__price">' + price + '</div><p class="trd-plan__note">' + note + '</p>' +
          '<ul class="trd-plan__feats">' + p.f.map(function (x) { return '<li>' + CHECK + esc(x) + '</li>'; }).join('') + '</ul>' + cta + '</div>';
      }
      function render() { grid.innerHTML = plans.map(card).join(''); }
      qsa('[data-bill]', box).forEach(function (b) {
        b.addEventListener('click', function () {
          period = b.getAttribute('data-bill');
          qsa('[data-bill]', box).forEach(function (x) { x.classList.toggle('is-on', x === b); });
          render();
        });
      });
      render();
      var api = box.getAttribute('data-api');
      if (!api) return;
      fetch(api, { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (res) {
        var list = res && res.data && res.data.plans;
        if (!list || !list.length) return;
        var pct = 0;
        plans = list.slice().sort(function (a, b) { return (a.sort_order || 0) - (b.sort_order || 0); }).map(function (p) {
          if (p.yearly_discount_percent) pct = Math.max(pct, p.yearly_discount_percent);
          return {
            t: p.title_en || p.title, g: p.tagline_en || p.tagline,
            m: p.monthly_price ? p.monthly_price.usd : null, y: p.yearly_price ? p.yearly_price.usd : null,
            pop: !!p.popular, sales: !!p.contact_sales,
            f: (p.card_features || []).map(function (x) { return x.label_en || x.label; })
          };
        });
        if (save && pct) save.textContent = 'Save ' + pct + '%';
        render();
      }).catch(function () {});
    });
  }

  function init(scope) {
    reveals(scope);
    counters(scope);
    tabs(scope);
    stack(scope);
    journey(scope);
    scenes(scope);
    marquee(scope);
    flow(scope);
    pricing(scope);
  }

  function start() {
    header();
    smooth();
    init(d);
    d.addEventListener('shopify:section:load', function (e) { init(e.target); });
  }
  if (d.readyState !== 'loading') start(); else d.addEventListener('DOMContentLoaded', start);
})();
